import type { VideoJsPlayer } from 'video.js';

import { useEffect, useState } from 'react';

import { VideoJsNativeEvent } from '../videojs-event';

export function useVideoDataLoaded(player: VideoJsPlayer) {
  const [isVideoDataLoaded, setIsVideoDataLoaded] = useState(false);

  useEffect(() => {
    const onVideoDataLoaded = () => {
      setIsVideoDataLoaded(true);
    };
    const onLoadStart = () => {
      setIsVideoDataLoaded(false);
    };

    player.on(VideoJsNativeEvent.LOADED_DATA, onVideoDataLoaded);
    player.on(VideoJsNativeEvent.LOAD_START, onLoadStart);

    return () => {
      player.off(VideoJsNativeEvent.LOADED_DATA, onVideoDataLoaded);
      player.off(VideoJsNativeEvent.LOAD_START, onLoadStart);
    };
  }, [player]);

  return isVideoDataLoaded;
}
